import { useInView } from '../../hooks/useInView';
import { Star, Users } from 'lucide-react';

const testimonials = [
  { text: 'Eu nunca consegui organizar minhas finanças até conhecer a Aretê. Agora registro tudo pelo celular em segundos e já consegui juntar minha reserva de emergência em 4 meses! O dashboard é incrível.', name: 'Mariana Oliveira', role: 'Empreendedora' },
  { text: 'Cara, a Aretê mudou minha vida! Eu gastava sem controle e agora consigo ver exatamente pra onde vai cada real. As metas me motivam demais. Já recomendei pra toda minha família e amigos. Vale cada centavo!', name: 'Lucas Ferreira', role: 'Desenvolvedor' },
  { text: 'Uso a Aretê todo dia logo cedo pra checar meu saldo e registrar os gastos do dia anterior. As dicas de investimento por IA são um diferencial absurdo. Não troco por nada!', name: 'Camila Santos', role: 'Advogada' },
  { text: 'Minha esposa e eu usamos a Aretê juntos pra controlar as finanças da casa. A função de metas nos ajudou a planejar nossa viagem dos sonhos. Já economizamos mais de R$ 15.000 em 10 meses!', name: 'Ana e Pedro Costa', role: 'Casal' },
  { text: 'Sou autônomo e sempre tive dificuldade em separar gastos pessoais dos profissionais. A Aretê com as categorias e relatórios resolveu isso. Os relatórios via WhatsApp são muito práticos!', name: 'Rafael Mendes', role: 'Fotógrafo' },
  { text: 'Comecei com o plano Despertar e em 2 meses já fiz upgrade pro Elite. A IA que dá dicas de investimento me fez começar a investir pela primeira vez na vida. Já tenho R$ 3.000 investidos! Obrigada Aretê!', name: 'Juliana Ribeiro', role: 'Professora' },
];

function TestimonialCard({ testimonial, index, isInView }) {
  return (
    <div
      data-testid={`testimonial-${index}`}
      className={`rounded-2xl border border-border/60 bg-card/60 backdrop-blur-sm p-6 hover:bg-card/90 hover:border-primary/25 transition-all duration-500 hover:-translate-y-1 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      style={{ transitionDelay: `${index * 90}ms`, transitionProperty: 'opacity, transform, background-color, border-color', transitionDuration: '700ms' }}
    >
      <div className="flex items-center gap-0.5 mb-4 text-primary">
        {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-3.5 h-3.5 fill-current" />)}
      </div>
      <p className="text-sm text-foreground/90 leading-relaxed mb-6 italic">
        &ldquo;{testimonial.text}&rdquo;
      </p>
      <div className="pt-4 border-t border-border/40">
        <div className="text-sm font-semibold text-foreground">{testimonial.name}</div>
        <div className="text-xs text-muted-foreground">{testimonial.role}</div>
      </div>
    </div>
  );
}

export default function TestimonialsSection() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section className="relative py-32 overflow-hidden" data-testid="testimonials-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_50%_50%,hsl(var(--primary)/0.05),transparent)]" />

      <div className="relative mx-auto max-w-7xl px-6" ref={ref}>
        <div className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs font-semibold uppercase tracking-widest text-primary mb-4 block">Depoimentos</span>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-foreground mb-6">Quem usa, recomenda!</h2>
          <p className="text-muted-foreground text-lg">
            Veja o que nossos usuários dizem sobre a experiência com a Aretê no dia a dia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} index={i} isInView={isInView} />)}
        </div>

        {/* Bottom social proof strip */}
        <div className={`flex flex-wrap items-center justify-center gap-8 pt-10 border-t border-border/40 transition-all duration-700 ${isInView ? 'opacity-100' : 'opacity-0'}`} style={{ transitionDelay: '600ms' }}>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-0.5 text-primary">
              {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-4 h-4 fill-current" />)}
            </div>
            <span className="text-sm font-semibold text-foreground">4.9/5</span>
            <span className="text-xs text-muted-foreground">(200+ avaliações)</span>
          </div>
          <div className="flex items-center gap-2">
            <Users className="w-4 h-4 text-primary" />
            <span className="text-sm"><span className="font-semibold text-foreground">+200</span> <span className="text-muted-foreground">usuários ativos</span></span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500" />
            <span className="text-sm"><span className="font-semibold text-foreground">98%</span> <span className="text-muted-foreground">taxa de satisfação</span></span>
          </div>
        </div>
      </div>
    </section>
  );
}
